// extracted by mini-css-extract-plugin
export var pin = "map-module--pin--pZlai";
export var pinText = "map-module--pin-text--1CACK";
export var pinIcon = "map-module--pin-icon--P+4d8";